export default "__VITE_ASSET__CbN87aVk__"